import _defineProperty from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _createClass from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _asyncToGenerator from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/minjunkweon.github.io/minjunkweon.github.io/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { getCurrentHub } from '@sentry/core';
import { logger, updateRateLimits, isRateLimited } from '@sentry/utils';
import { REPLAY_EVENT_NAME, UNABLE_TO_SEND_REPLAY } from '../constants.js';
import { createReplayEnvelope } from './createReplayEnvelope.js';
import { prepareRecordingData } from './prepareRecordingData.js';
import { prepareReplayEvent } from './prepareReplayEvent.js';

/**
 * Send replay attachment using `fetch()`
 */
function sendReplayRequest(_x) {
  return _sendReplayRequest.apply(this, arguments);
}
/**
 * This error indicates that we hit a rate limit API error.
 */
function _sendReplayRequest() {
  _sendReplayRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var recordingData, replayId, segment_id, includeReplayStartTimestamp, eventContext, timestamp, session, options, preparedRecordingData, urls, errorIds, traceIds, initialTimestamp, hub, client, scope, transport, dsn, baseEvent, replayEvent, envelope, response, rateLimits;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            recordingData = _ref.recordingData, replayId = _ref.replayId, segment_id = _ref.segmentId, includeReplayStartTimestamp = _ref.includeReplayStartTimestamp, eventContext = _ref.eventContext, timestamp = _ref.timestamp, session = _ref.session, options = _ref.options;
            preparedRecordingData = prepareRecordingData({
              recordingData: recordingData,
              headers: {
                segment_id: segment_id
              }
            });
            urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, initialTimestamp = eventContext.initialTimestamp;
            hub = getCurrentHub();
            client = hub.getClient();
            scope = hub.getScope();
            transport = client && client.getTransport();
            dsn = client && client.getDsn();
            if (!(!client || !scope || !transport || !dsn || !session.sampled)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            baseEvent = _objectSpread(_objectSpread({
              // @ts-ignore private api
              type: REPLAY_EVENT_NAME
            }, includeReplayStartTimestamp ? {
              replay_start_timestamp: initialTimestamp / 1000
            } : {}), {}, {
              timestamp: timestamp / 1000,
              error_ids: errorIds,
              trace_ids: traceIds,
              urls: urls,
              replay_id: replayId,
              segment_id: segment_id,
              replay_type: session.sampled
            });
            _context.next = 13;
            return prepareReplayEvent({
              scope: scope,
              client: client,
              replayId: replayId,
              event: baseEvent
            });
          case 13:
            replayEvent = _context.sent;
            if (replayEvent) {
              _context.next = 18;
              break;
            }
            // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
            client.recordDroppedEvent('event_processor', 'replay_event', baseEvent);
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('An event processor returned `null`, will not send event.');
            return _context.abrupt("return");
          case 18:
            replayEvent.tags = _objectSpread(_objectSpread({}, replayEvent.tags), {}, {
              sessionSampleRate: options.sessionSampleRate,
              errorSampleRate: options.errorSampleRate
            });

            /*
            For reference, the fully built event looks something like this:
            {
                "type": "replay_event",
                "timestamp": 1670837008.634,
                "error_ids": [
                    "errorId"
                ],
                "trace_ids": [
                    "traceId"
                ],
                "urls": [
                    "https://example.com"
                ],
                "replay_id": "eventId",
                "segment_id": 3,
                "replay_type": "error",
                "platform": "javascript",
                "event_id": "eventId",
                "environment": "production",
                "sdk": {
                    "integrations": [
                        "BrowserTracing",
                        "Replay"
                    ],
                    "name": "sentry.javascript.browser",
                    "version": "7.25.0"
                },
                "sdkProcessingMetadata": {},
                "tags": {
                    "sessionSampleRate": 1,
                    "errorSampleRate": 0,
                }
            }
            */
            envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
            _context.prev = 20;
            _context.next = 23;
            return transport.send(envelope);
          case 23:
            response = _context.sent;
            _context.next = 29;
            break;
          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](20);
            throw new Error(UNABLE_TO_SEND_REPLAY);
          case 29:
            if (response) {
              _context.next = 31;
              break;
            }
            return _context.abrupt("return", response);
          case 31:
            rateLimits = updateRateLimits({}, response);
            if (!isRateLimited(rateLimits, 'replay')) {
              _context.next = 34;
              break;
            }
            throw new RateLimitError(rateLimits);
          case 34:
            if (!(typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300))) {
              _context.next = 36;
              break;
            }
            throw new TransportStatusCodeError(response.statusCode);
          case 36:
            return _context.abrupt("return", response);
          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[20, 26]]);
  }));
  return _sendReplayRequest.apply(this, arguments);
}
var RateLimitError = /*#__PURE__*/function (_Error) {
  _inherits(RateLimitError, _Error);
  var _super = _createSuper(RateLimitError);
  function RateLimitError(rateLimits) {
    var _this;
    _classCallCheck(this, RateLimitError);
    _this = _super.call(this, 'Rate limit hit');
    _this.rateLimits = rateLimits;
    return _this;
  }
  return _createClass(RateLimitError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * This error indicates that the transport returned an invalid status code.
 */
var TransportStatusCodeError = /*#__PURE__*/function (_Error2) {
  _inherits(TransportStatusCodeError, _Error2);
  var _super2 = _createSuper(TransportStatusCodeError);
  function TransportStatusCodeError(statusCode) {
    _classCallCheck(this, TransportStatusCodeError);
    return _super2.call(this, "Transport returned status code ".concat(statusCode));
  }
  return _createClass(TransportStatusCodeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { RateLimitError, TransportStatusCodeError, sendReplayRequest };